var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#0000E3",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6823 17.75V19.25H5.05729V17.9609L8.76042 13.9219C9.16667 13.4635 9.48698 13.0677 9.72135 12.7344C9.95573 12.401 10.1198 12.1016 10.2135 11.8359C10.3125 11.5651 10.362 11.3021 10.362 11.0469C10.362 10.6875 10.2943 10.3724 10.1589 10.1016C10.0286 9.82552 9.83594 9.60938 9.58073 9.45312C9.32552 9.29167 9.01563 9.21094 8.65104 9.21094C8.22917 9.21094 7.875 9.30208 7.58854 9.48438C7.30208 9.66667 7.08594 9.91927 6.9401 10.2422C6.79427 10.5599 6.72135 10.9245 6.72135 11.3359H4.83854C4.83854 10.6745 4.98958 10.0703 5.29167 9.52344C5.59375 8.97135 6.03125 8.53385 6.60417 8.21094C7.17708 7.88281 7.86719 7.71875 8.67448 7.71875C9.4349 7.71875 10.0807 7.84635 10.612 8.10156C11.1432 8.35677 11.5469 8.71875 11.8229 9.1875C12.1042 9.65625 12.2448 10.2109 12.2448 10.8516C12.2448 11.2057 12.1875 11.5573 12.0729 11.9062C11.9583 12.2552 11.7943 12.6042 11.5807 12.9531C11.3724 13.2969 11.125 13.6432 10.8385 13.9922C10.5521 14.3359 10.237 14.6849 9.89323 15.0391L7.43229 17.75H12.6823ZM21.987 15.1953V16.6953H13.7839L13.7214 15.5625L18.6276 7.875H20.1354L18.5026 10.6719L15.6823 15.1953H21.987ZM20.5651 7.875V19.25H18.6823V7.875H20.5651Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/24.62d729a9203edf48b9f00b490d978ef8.svg";
export { ForwardRef as ReactComponent };